// Centralised contact info for the firm.
export const CONTACT = {
  firmName: "Rodríguez Valuación y DRO",
  founder: "Arq. Angel Rodríguez Juárez",
  city: "Puebla, Puebla, México",
  address: "Calle 2 Sur 4905, Col. Las Palmas",
  addressFull: "Calle 2 Sur 4905, Col. Las Palmas, Puebla, Puebla",
  phoneRaw: "2225777958",
  phoneIntl: "+52 222 577 7958",
  phoneDisplay: "222 577 7958",
  email: "yeshua0219@gmail.com",
  hoursWeek: "Lunes a Viernes · 9:00 – 18:00 hrs",
  hoursSat:  "Sábado · 9:00 – 13:00 hrs",
};

export const WA_MESSAGE = encodeURIComponent(
  "Hola, me gustaría solicitar información sobre sus servicios de valuación."
);

export const WHATSAPP_URL = `https://wa.me/52${CONTACT.phoneRaw}?text=${WA_MESSAGE}`;
export const TEL_URL = `tel:+52${CONTACT.phoneRaw}`;
export const MAIL_URL = `mailto:${CONTACT.email}?subject=${encodeURIComponent("Solicitud de cotización — Rodríguez Valuación y DRO")}`;

// Se usa en el schema.org JSON-LD (SEO). Debe coincidir con la URL real
// donde vive el sitio.
export const SITE_URL = "https://rodriguezvaluacion.com";

// Municipios donde el despacho ofrece servicio (usado en el schema local).
export const AREA_SERVED = [
  "Puebla",
  "San Andrés Cholula",
  "San Pedro Cholula",
  "Atlixco",
  "Cuautlancingo",
  "Amozoc",
  "Tehuacán",
];
